import { createFileRoute } from '@tanstack/react-router';

import { DmaQualityPage } from '@/features/esg/dma/components/DmaQualityPage';

export const Route = createFileRoute('/_authenticated/esg/double-materiality/$assessmentId/quality')({
  component: DmaQualityRoute,
});

function DmaQualityRoute() {
  const { assessmentId } = Route.useParams();
  return <DmaQualityPage assessmentId={assessmentId} />;
}
